// Import the functions you need from the SDKs you need
import { getAnalytics, isSupported, logEvent, Analytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { initializeAuth, browserLocalPersistence, browserPopupRedirectResolver } from "firebase/auth";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAb0_eEvHJwT2sB_FsqdUsKWP4qpkeNOno", // https://console.cloud.google.com/apis/credentials?project=wordle-cz
  authDomain: "wordle-cz.firebaseapp.com",
  databaseURL:
    "https://wordle-cz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "wordle-cz",
  storageBucket: "wordle-cz.appspot.com",
  messagingSenderId: "474314331888",
  appId: "1:474314331888:web:cbd92dea27ef201eb51435",
  measurementId: "G-KHXNCX047H",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});
export const firestore = initializeFirestore(app, {
  localCache: memoryLocalCache(),
});

let analyticsInstance: Analytics | null = null;
isSupported().then((supported) => {
  if (supported) {
    analyticsInstance = getAnalytics(app);
  }
});

export const logMyEvent = (event: string, eventParam: string = "") => {
  if (analyticsInstance) {
    logEvent(analyticsInstance, event, { param1: eventParam });
  }
};
